import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { promoGamerCities } from 'src/app/utils/promo-gamer-cities';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  locationsUrl = `${environment.API_URL}/Shellbox_Location`;

  constructor(private http: HttpClient) { }

  private locationData = promoGamerCities

  get()
  {
    return this.http.get(this.locationsUrl);
  }

  currentPosition(): Promise<any>
  {
    return new Promise((resolve, reject) => {

      navigator.geolocation.getCurrentPosition(resp => {

        resolve({lng: resp.coords.longitude, lat: resp.coords.latitude});
      },
      err => {
          if(err.code === 1){
            resolve(false)
          }
          //reject(err);
        });
    });

  }

  getProvinces(): string[] {
    return this.locationData.map((item : any) => item.provincia);

  }

  getCities(province: string): string[] {
    const normalize = (str: string) =>
      str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  
    const normalizedProvince = normalize(province);
  
    const location = this.locationData.find((item: any) =>
      normalize(item.provincia) === normalizedProvince
    );
  
    return location ? [...location.ciudades] : [];
  }
}
